import styled from 'styled-components'
import {TabsPure, media, Col} from '@modifi/ui'
import {mediumGray} from '@modifi/colors'

export const CardWrapper = styled.div`
  width: 250px;
  min-height: 100px;
  white-space: break-spaces;
  padding: 16px;
  margin: 0 16px;
`

export const StyledTabsPure = styled(TabsPure)`
  flex-direction: row;
  border-bottom: 1px solid ${mediumGray};
  align-items: flex-end;

  button {
    font-size: 24px;
    margin: 0 16px;
    font-weight: 700;
    text-transform: uppercase;
    ${media.xs`
      font-size: 20px;
      white-space: pre-wrap;
      height: 100%;
      padding: 8px 0px;
    `}
  }

  button:not(:first-child) {
    ${media.xs`
      margin-left: 20px;
    `}
  }

  button::after {
    width: calc(100% + 2 * 16px);
    height: 7px;
    left: -16px;
  }
`

export const StyledImgCol = styled(Col)`
  > img {
    height: 50px;
  }
`
